// This is duplicated from @hungryroot/quiz to avoid circular deps. If the experiment wins, this should be moved to the quiz package
export enum Goals {
  SaveTime = 5,
  ImproveHealth = 2,
  LoseWeight = 3,
  TryNewThings = 9,
  EatLessTakeout = 10,
  GroceryShopLess = 4,
  WasteLessFood = 11,
  SaveMoney = 7,
  EatMoreVeggiesWithFamily = 8,
  SimplifyCooking = 12,
  LowerStress = 13,
}
